import { render, staticRenderFns } from "./SearchedFbaProduct.vue?vue&type=template&id=c88ddd78&scoped=true&"
import script from "./SearchedFbaProduct.vue?vue&type=script&lang=js&"
export * from "./SearchedFbaProduct.vue?vue&type=script&lang=js&"
import style0 from "./SearchedFbaProduct.vue?vue&type=style&index=0&id=c88ddd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88ddd78",
  null
  
)

export default component.exports